import Immutable from 'immutable';
import {
  HOME_PATH,
  TRAFFIC_UNIT_PATH,
  DRIVER_UNIT_PATH,
  DRIVER_PATH,
  DRIVER_BUS_ASSIGNMENT_PATH,
  DRIVER_MOVEMENT_HISTORY_PATH,
  DRIVER_ACTIVITY_PATH,
  DRIVER_FOR_SCHEDULING_PATH,
  DRIVER_TASK_SUMMARY_PATH,
  ACTIVITY_BY_DRIVER_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    { id: 'drivers', title: 'Conductores', path: DRIVER_PATH, icon: 'male' },
    {
      id: 'drivers-assignment',
      title: 'Asignación de Conductores',
      path: DRIVER_BUS_ASSIGNMENT_PATH,
      icon: 'certificate',
    },
    {
      id: 'driver-movement-history',
      title: 'Movimientos de Conductores',
      path: DRIVER_MOVEMENT_HISTORY_PATH,
      icon: 'history',
    },
    {
      id: 'driver-schedule',
      title: 'Programación de Conductores',
      path: DRIVER_FOR_SCHEDULING_PATH,
      icon: 'calendar',
    },
    {
      id: 'driver-activity',
      title: 'Tareo de Conductores',
      path: DRIVER_ACTIVITY_PATH,
      icon: 'list-alt',
    },
    {
      id: 'activity-by-driver',
      title: 'Tareo por Conductor',
      path: ACTIVITY_BY_DRIVER_PATH,
      icon: 'list-ul',
    },
    {
      id: 'driver-task-summary',
      title: 'Resumen de Tareo Conductores',
      path: DRIVER_TASK_SUMMARY_PATH,
      icon: 'file-text',
    },
  ],
  breadcrumbs: [
    { text: 'Inicio', tag: 'a', href: HOME_PATH },
    { text: 'Gestión de Tráfico', tag: 'a', href: TRAFFIC_UNIT_PATH },
    { text: 'Gestión de Conductores', tag: 'span', href: DRIVER_UNIT_PATH },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
